import React from "react";
import { Link } from "react-router-dom";

export const ServiceOneItem = ({ service }) => {
  return (
    <div className="services-item">
      <div className="services-content">
        <div className="content-top">
          <div className="icon">
            <i className={service.icon}></i>
          </div>

          <div>
            <h2 className="title">{service.title}</h2>
            <p>{service.subtitle}</p>
          </div>
        </div>

        <div className="services-thumb">
          <img src={service.src} alt={service.title} />

          <Link to={service.href} className="btn transparent-btn">
            Learn More
          </Link>
        </div>

        <ul className="list-wrap">
          {service.list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
